import PropTypes from 'prop-types'
import { Redirect, Route } from "react-router-dom"

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  returnTranslation,
  ...rest
}) => {
  // const history = useHistory();
  
  // useEffect(() => {
  //   console.log([history?.location?.pathname, history])
  // }, [history?.location])

  return (
    <Route
      {...rest}
      render={props => {
        if (isAuthProtected && !localStorage.getItem("authUser")) {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          )
        }

        return (
          Layout ? (
            <Layout returnTranslation={returnTranslation}>
              <Component {...props} returnTranslation={returnTranslation} />
            </Layout>
          ) : (
            <Component {...props} returnTranslation={returnTranslation} />
          )
          
        )
      }}
    />
  )
}

AppRoute.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any
}

export default AppRoute
